import type { FC } from 'react'

import SubnavBase, * as Subnav from '@segment/matcha/recipes/Subnav'

import useScrollToAnchor from '@segment/utils/useScrollToAnchor'

import data from './data'

const TITLE = `Trust Center`

const Subnavigation: FC = () => (
  <SubnavBase aria-label={TITLE} label={TITLE}>
    {data.map((item) => {
      const scroll = useScrollToAnchor(item.id, -100)
      return (
        <Subnav.Item
          key={item.label}
          label={item.label}
          href={item.href}
          onClick={(e) => {
            e.preventDefault()
            scroll()
          }}
        />
      )
    })}
  </SubnavBase>
)

export default Subnavigation
